import React, { useEffect, useRef, useState } from 'react';

// True when the element renders no real content (ignores display:contents wrappers).
const hasNoContent = (el) => !el || !el.querySelector('*:not([data-ve-dynamic])');

export const useIsEmpty = (ref) => {
  const [empty, setEmpty] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const check = () => setEmpty(hasNoContent(el));
    check();
    const mo = new MutationObserver(check);
    mo.observe(el, { childList: true, subtree: true });
    return () => mo.disconnect();
  }, [ref]);
  return empty;
};

export const fitCols = (min) => ({ gridTemplateColumns: `repeat(auto-fit, minmax(min(100%, ${min}px), 1fr))` });

export const FILL = '[&>*]:h-full [&>span>*]:h-full';

export const AutoBlock = ({ children, className = '', ...rest }) => {
  const ref = useRef(null);
  const empty = useIsEmpty(ref);
  return (
    <div ref={ref} className={`min-w-0 ${FILL} ${empty ? 'hidden' : ''} ${className}`} {...rest}>
      {children}
    </div>
  );
};
